import { getWarehouseStockFilterOptions } from 'app/dataProviders/warehouse/stock'
import { WarehouseStockFilterOptions } from 'app/common/types/warehouse/stock'

let warehouseStockFilterAbortController: AbortController | undefined
export const getFilterWarehouseStock = async () => {
  warehouseStockFilterAbortController?.abort()
  warehouseStockFilterAbortController = new AbortController()
  const options = await getWarehouseStockFilterOptions(warehouseStockFilterAbortController?.signal)
  if (options) {
    return options
  }
  return {
    orgs: [] as WarehouseStockFilterOptions['orgs'],
    buildingsByOrgId: {} as WarehouseStockFilterOptions['buildingsByOrgId'],
    isCentralWarehouse: false,
  } as WarehouseStockFilterOptions
}
